module.exports = __webpack_public_path__ + "static/90-81e79b6ccf7d9e423be9bf84a0f2ccdb.png";